import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { UserService } from '../../dataServices/userService';
import { AzureLoggerService } from '../../services/azureLoggerService';

@Component({
    selector: 'self-ins-forgot-password',
    templateUrl: './forgot-password-page.component.html',
    styleUrls: ['./forgot-password-page.component.scss']
})
export class ForgotPasswordPageComponent {
    public email: string = '';

    constructor(private progressBar: NgProgress,
                private toastrService: ToastrService,
                private userService: UserService,
                private azureLoggerService: AzureLoggerService,
                private router: Router) {
    }

    public onSubmit() {
        this.progressBar.ref().start();
        this.userService.forgotPassword(this.email)
            .pipe(
                finalize(() => this.progressBar.ref().complete())
            )
            .subscribe(
                _ => {
                    this.toastrService.success(
                        `Instructions have been sent to ${this.email}`
                    );
                    setTimeout(() => this.router.navigate(['']), 1000);
                },
                error => {
                    this.azureLoggerService.logException(error);
                    this.toastrService.error('API error:' + error._body);
                }
            );
    }
}